<template>
  <div :class="$style.root">
    <div :class="$style.rotated">
      <slot/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RotatedHeading',
};
</script>

<style lang="scss" module>
@import '~styles/variables';
@import '~styles/helpers';

.root {
  @extend %content;

  position: relative;
}

.rotated {
  transform: rotateZ(-90deg);
  display: flex;
  justify-content: flex-end;
  width: 1px;
  white-space: nowrap;
  position: absolute;
  top: 0;
  left: -80px;
  text-transform: uppercase;

  @include media('<=desktop-xlg') {
    left: -50px;
  }

  @include media('<=desktop-xlg') {
    position: static;
    transform: rotateZ(0);
    width: auto;
    justify-content: flex-start;
  }

  @include media('<=desktop') {
    display: none;
  }
}

.rotated > * {
  color: $gray-3;
  font-size: 14px;
  line-height: 20px;
  font-weight: normal;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/RotatedHeading.vue